export default "__VITE_ASSET__BJA2lGI7__"